import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { fetchFavoriteCount } from './userActions';
import { Favorite, FavoriteResponse, FavoriteState } from './types';

const initialState: FavoriteState = {
  favorite: null,
  loading: false,
  error: null
};

const favoriteSlice = createSlice({
  name: 'favorite',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchFavoriteCount.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchFavoriteCount.fulfilled, (state, action: PayloadAction<FavoriteResponse>) => {
        state.loading = false;
        state.favorite = action.payload.data;
        state.error = null;
      })
      .addCase(fetchFavoriteCount.rejected, (state, action: PayloadAction<any>) => {
        state.loading = false;
        state.error = action.payload;
      });
  }
});

export default favoriteSlice.reducer;